export const LOAD_USER_STATE = 'STORAGE/LOAD_USER_STATE'
